/**
 * PT-1708: Убрать ajax запрос по курортам, если даты не введены
 */
export const seoExperiment1708 = function() {
    return location.pathname === '/krasnaya-polyana/';
};
